var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0103 5.35082C7.27586 4.61638 6.08509 4.61638 5.35064 5.35082C4.61619 6.08527 4.61619 7.27604 5.35064 8.01049L9.34014 12L5.35064 15.9895C4.61619 16.7239 4.61619 17.9147 5.35064 18.6492C6.08509 19.3836 7.27586 19.3836 8.0103 18.6492L11.9998 14.6597L15.9893 18.6492C16.7237 19.3836 17.9145 19.3836 18.649 18.6492C19.3834 17.9147 19.3834 16.7239 18.649 15.9895L14.6595 12L18.649 8.01049C19.3834 7.27604 19.3834 6.08527 18.649 5.35082C17.9145 4.61638 16.7237 4.61638 15.9893 5.35082L11.9998 9.34032L8.0103 5.35082Z",
    fill: "#42474D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.46575677d7b7473d06119a09e77e8805.svg";
export { ForwardRef as ReactComponent };